// Supabase Storage utilities for image uploads
import { supabase } from './supabase';
export const uploadImage = async (file, bucket = 'blog-images') => {
    try {
        // Generate unique filename
        const fileExt = file.name.split('.').pop();
        const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
        // Upload file to Supabase Storage
        const { error } = await supabase.storage
            .from(bucket)
            .upload(fileName, file, {
            cacheControl: '3600',
            upsert: false
        });
        if (error) {
            console.error('Upload error:', error);
            return null;
        }
        // Get public URL
        const { data: { publicUrl } } = supabase.storage
            .from(bucket)
            .getPublicUrl(fileName);
        return publicUrl;
    }
    catch (error) {
        console.error('Error uploading image:', error);
        return null;
    }
};
export const deleteImage = async (url, bucket = 'blog-images') => {
    try {
        // Extract filename from URL
        const urlParts = url.split('/');
        const fileName = urlParts[urlParts.length - 1];
        const { error } = await supabase.storage
            .from(bucket)
            .remove([fileName]);
        if (error) {
            console.error('Delete error:', error);
            return false;
        }
        return true;
    }
    catch (error) {
        console.error('Error deleting image:', error);
        return false;
    }
};
